module.exports = __webpack_public_path__ + "img/van.20ba0ff3.png";